import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { Dropdown, Modal } from 'bootstrap';
import uuid from 'react-uuid';
import PaymentDataDetail from './PaymentDataDetail';
import DateService from '../../services/DateService';

const PaymentDetailModal = forwardRef((props, ref) => {
    const modalElem = useRef(null);
    const modal = useRef(null);
    const [modalId] = useState(uuid());
    const [selectId, setSelectId] = useState("")
    const [expenseDetail, setExpenseDetail] = useState("")

    useImperativeHandle(ref, () => ({
        paymentModalInit: (id, expenseDetail) => {
            setExpenseDetail(expenseDetail)
            setSelectId(id)
            modalOpen();
        },

    }));

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose = () => {
        if (modal.current) { modal.current.hide(); }
    };


    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });

        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, [modalId]);


    return (
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Payment Detail
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className='p-1 bg-light border-bottom'>
                        <table className='table table-sm mb-0 table-borderless text-sm'>
                            <tbody>
                                <tr>
                                    <td>Expense Date</td>
                                    <th>
                                         {expenseDetail?.expense_date ? DateService.dateFormat(expenseDetail?.expense_date) : "-"}
                                    </th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Expense For </td>
                                    <th>
                                        {expenseDetail.expense_for
                                            ? expenseDetail?.expense_for
                                                .replace(/_/g, " ")
                                                .replace(/\b\w/g, (char) => char.toUpperCase())
                                            : "-"}
                                    </th>
                                </tr>
                                <tr>
                                    <td>Expense Id</td>
                                    <th>
                                        {expenseDetail.transaction_id}
                                    </th>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="modal-body">
                        <PaymentDataDetail paymentId={selectId} />
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Close
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
});

export default PaymentDetailModal;


